__turbopack_context__.v({
  "banner": "ProcedureGate-module__La67oG__banner",
  "bannerBody": "ProcedureGate-module__La67oG__bannerBody",
  "bannerIcon": "ProcedureGate-module__La67oG__bannerIcon",
  "bannerLink": "ProcedureGate-module__La67oG__bannerLink",
  "bannerList": "ProcedureGate-module__La67oG__bannerList",
  "bannerTitle": "ProcedureGate-module__La67oG__bannerTitle",
  "block": "ProcedureGate-module__La67oG__block",
  "blockFooter": "ProcedureGate-module__La67oG__blockFooter",
  "blockHead": "ProcedureGate-module__La67oG__blockHead",
  "blockHeadBody": "ProcedureGate-module__La67oG__blockHeadBody",
  "blockIcon": "ProcedureGate-module__La67oG__blockIcon",
  "blockList": "ProcedureGate-module__La67oG__blockList",
  "blockProcedures": "ProcedureGate-module__La67oG__blockProcedures",
  "blockText": "ProcedureGate-module__La67oG__blockText",
  "blockTitle": "ProcedureGate-module__La67oG__blockTitle",
  "logoutBtn": "ProcedureGate-module__La67oG__logoutBtn",
});
